<template>
    <v-footer class="heightMobileFooter" :color="color" :dark="transparent" :light="!transparent" style="width:100%; flex: 1 1 32px;">
        <v-card-text class="white--text pt-0" style="padding-bottom: 0px;">
            <span class="no-selectable fullWidthMobile black--text" style="float: left; margin-top: 5px;">WeLicense &copy; 2019</span>
            <ul class="menu-list-footer fullWidthMobile tableMobile" style="float: left;">
                <li><span class="black--text" @click="goPrivacy">Privacy</span></li>
                <li><span class="black--text" @click="goTC">T&C</span></li>
                <li><span class="black--text" @click="goPremium">Enterprise</span></li>
            </ul>
            <span class="no-selectable fullWidthMobile black--text" style="float: right;margin-top: 5px;white-space: nowrap;width: 0px; direction: rtl;">{{copyright}}&#x200E;</span>
        </v-card-text>
    </v-footer>
</template>

<script>

    import { VFooter, VCardText } from 'vuetify/lib'

    export default {
        name: 'Footer',
        components: {
            VFooter,
            VCardText
        },
        props: {
            transparent: Boolean
        },
        data () {
            return {
                color: "undefined",
                copyright: "",
            }
        },
        created() {
            if (this.transparent) {
                this.color = "transparent";
            }
        },
        methods: {
            setCopyright(copy) {
                this.copyright=copy;
            },
            goRhino() {
                this.$router.push({name: 'rhino'});
            },
            goDocumentation() {
                this.$router.push({name: 'documentation'});
            },
            goSupport() {
                this.$router.push({name: 'support'});
            },
            goAbout() {
                this.$router.push({name: 'about'});
            },
            goPrivacy() {
                this.$router.push({name: 'privacy'});
            },
            goTC() {
                this.$router.push({name: 'terms'});
            },
            goPremium() {
                window.location = 'https://welicense.io/pricing/';
                //this.$router.push({name: 'rates'});
            }
        }
    };
</script>
<style scoped>
    @media screen and (max-width: 950px) {
        .fullWidthMobile{
            width: 100% !important;
        }
        .heightMobileFooter{
            height: 111px !important;
        }
        .fullWidthMobile li{
            display: inline-block;
        }
        .tableMobile{
            display:table !important;
        }
    }
    @media screen and (min-width: 950px) {
        .tableMobile{
            margin-left: 25px !important;
        }
    }
    .menu-list-footer{
        list-style: none;
        margin: 0;
        padding: 0;
        display: inline-flex
    }
    .menu-list-footer li{
        margin: 5px;
        cursor: pointer;
    }
</style>